/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Markdown from '@gcc/pip-components/dist/Markdown';
import { GridItem } from '@gcc/pip-components/dist/grids';
import {
  RichContent,
  ProductDescription,
} from '@gcc/pip-components/dist/templates/ProductOverview/styles';

const CoreProductOverview = ({
  richContent,
  productDescription,
  shortDescription,
  isCt,
  markdownComponent: Markd,
}) => (
  <>
    {
      richContent
      && (
        <GridItem
          sm={12}
          dangerouslySetInnerHTML={{ __html: richContent }}
        />
      )
    }
    <GridItem md={7}>
      <Markd source={productDescription} />
      { isCt && (
        <div className="salient_points">
          <Markdown source={shortDescription} />
        </div>
      )}
    </GridItem>
  </>
);

CoreProductOverview.propTypes = {
  productDescription: PropTypes.string.isRequired,
  richContent: PropTypes.string,
  markdownComponent: PropTypes.object,
  isCt: PropTypes.bool,
  shortDescription: PropTypes.string,
};

CoreProductOverview.defaultProps = {
  richContent: null,
  markdownComponent: Markdown,
  isCt: false,
  shortDescription: '',
};

export {
  CoreProductOverview as default,
  RichContent,
  ProductDescription,
};
